import React from 'react';
import { SpaceProps, LayoutProps, TypographyProps, ColorProps } from 'styled-system';
import { RouterLink, Anchor, Button } from './styles';
import { LinkProps as RRLinkProps } from 'react-router';

type SSProps = SpaceProps & LayoutProps & TypographyProps & ColorProps;

type RouterLikeProps = SSProps &
    Omit<RRLinkProps, 'to'> & {
        to: RRLinkProps['to'];
        href?: never;
        type?: never;
    };

type AnchorLikeProps = SSProps &
    React.AnchorHTMLAttributes<HTMLAnchorElement> & {
        href: string;
        to?: never;
        type?: never;
    };

type ButtonLikeProps = SSProps &
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
        to?: never;
        href?: never;
        type?: 'button';
    };

type Props = { children: React.ReactNode } & (RouterLikeProps | AnchorLikeProps | ButtonLikeProps);

const Link: React.FC<Props> = ({ children, ...otherProps }) => {
    if ('to' in otherProps && otherProps.to) {
        return <RouterLink {...(otherProps as RouterLikeProps)}>{children}</RouterLink>;
    }

    if ('href' in otherProps && otherProps.href) {
        const { rel, ...rest } = otherProps as AnchorLikeProps;
        return (
            <Anchor rel={rel ?? 'noopener noreferrer'} {...rest}>
                {children}
            </Anchor>
        );
    }

    const { type: _ignoredType, ...btnRest } = otherProps as ButtonLikeProps;
    return (
        <Button type="button" {...btnRest}>
            {children}
        </Button>
    );
};

export default Link;
